module.exports = __webpack_public_path__ + "../resources/images/illustration_inbox-278afdbc7c86ef9bd674e93dd01047e1.svg";